import { GetServerSidePropsContext, GetServerSidePropsResult } from 'next';

import ListCollection from 'types/redux/ListCollection';

import Plan from 'models/Plan';

import { LIST_MARKUP } from 'consts/api';
import { fillPage } from 'utils/translations';

import { list as listPlans } from 'requests/plans';

import Component from './component';
import { Props } from './types';

export async function getServerSideProps(context: GetServerSidePropsContext): Promise<GetServerSidePropsResult<Props>> {
    let plans: ListCollection<Plan> = LIST_MARKUP;

    try {
        await Promise.all([
            listPlans({
                page: 1,
                perPage: 10,
            }),
        ]).then(responses => {
            plans = responses[0]?.plans;
        });
    } catch (error) {
        console.error(error);
    }

    let pageTranslations = JSON.parse(JSON.stringify(require('locales/pl/pages/plans')?.default));
    const fillValues = {};
    pageTranslations = fillPage(pageTranslations, null, fillValues);

    return {
        props: {
            pageTranslations,
            plans: JSON.parse(JSON.stringify(plans)),
        },
    };
}

export default Component;

